import { download, generateCsv, mkConfig } from "export-to-csv"
import { toCurrency, toDinero } from "../../../../currency/currencyLib"
import { useDateTime } from "../../../../localization/useDateTime"
import { TransferItem } from "../supplierAcquiringReportsTypes"
import { useMoney } from "../../../../currency/useMoney"

export function useExportAcquiringReportsBankTransfersToCsv(startDate: string, endDate: string) {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({ locale: "da-DK" })
    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(startDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(endDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-reconciliation-bank-transfers-${formattedStartDate}_${formattedEndDate}`,
    })

    const handleExportRows = (transfers?: TransferItem[]) => {
        if (!transfers) return

        const exportRows = transfers.map((transfer) => {
            return {
                "From date": formattedStartDate,
                "To date": formattedEndDate,
                "Transfer ID": transfer.transferId ?? "",
                "Booked time": dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(transfer.bookingDate)),
                "Available time": dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(transfer.valueDate)),
                Merchant: transfer?.merchant
                    ? `${transfer.merchant.caseNumber ? `${transfer.merchant.caseNumber}, ` : ""} ${
                          transfer.merchant.name
                      }`
                    : "-",
                "Adyen account": transfer.balanceAccount,
                "Bank account": transfer.bankAccount.accountIdentifier,
                ["Amount" + ` (${moneyFactory.getLocalizedCurrencySymbol(toCurrency(transfer.amount.currency))})`]:
                    moneyFactory.formatAsNumber(toDinero(transfer.amount)),
            }
        })

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
